import { Config as ConfigType } from './types';
import { user } from './phm/user';
import { expert } from './phm/expert';
import { client } from './phm/client';
import { company } from './phm/company';
import { mission } from './phm/mission';
import { invitation } from './phm/invitation';
import { candidate } from './phm/candidate';
import { candidacy } from './phm/candidacy';
import { proposal } from './phm/proposal';
import { quotation } from './phm/quotation';
import { charge } from './phm/charge';
import { milestone } from './phm/milestone';
import { contract } from './phm/contract';
import { contractMilestone } from './phm/contractMilestone';
import { invoice } from './phm/invoice';
import { legalInformation } from './phm/legalInformation';
import { cgu } from './phm/cgu';
import { match } from './phm/match';
import { document } from './phm/document';
import { subCategory } from './phm/subCategory';
import { documentFile } from './phm/documentFile';
import { documentsCompanies } from './phm/documentsCompanies';
import { tag } from './phm/tag';
import { clientInvoice } from './phm/clientInvoice';
import { expertInvoice } from './phm/expertInvoice';
import { payments } from './phm/payments';
import { creditNotes } from './phm/creditNote';

export const config: ConfigType = {
  login: 'password',
  hash: 'replaceWithProperHash',
  locale: 'fr',
  name: 'phm',
  dashboard: false,
  theme: {
    primary: '#156275',
    secondary: '#156275',
    tertiary: '#0c073c',
    disabled: '#ada6e3',
    info: '#13D2B6',
    alert: '#fe6e61',
    success: '#13D2B6',
    cancel: '#8a8f94',
  },
  defaultCountry: 'fr',
  preferredCountries: ['fr', 'ma', 'ch', 'tn'],
  invoiceUploadedByUser: true,
  resources: [
    expert,
    client,
    user,
    subCategory,
    company,
    mission,
    invitation,
    candidate,
    candidacy,
    proposal,
    quotation,
    charge,
    milestone,
    contract,
    contractMilestone,
    invoice,
    creditNotes,
    legalInformation,
    document,
    documentFile,
    documentsCompanies,
    cgu,
    match,
    tag,
    expertInvoice,
    clientInvoice,
    payments,
  ],
};

export default config;
